import { useState, useEffect } from "react";
import LoadingModalComponent from "../../modals/loading-modal";
import { getGroupedPackages } from "../../api/services";
import { formatCurrency } from "../../helpers/currency";
import { useSearchParams } from "react-router-dom";
import CustomPagination from "../../components/pagination";
import CustomDateRangePicker from "../../components/date-picker";

export default function PackageIncomeScreen() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const DAYS_PER_PAGE = 12;
  const page = searchParams.get("page") || 1;
  const range = searchParams.get("range");

  useEffect(() => {
    setLoading(true);
    getGroupedPackages({ range, limit: DAYS_PER_PAGE, offset: (page - 1) * DAYS_PER_PAGE })
      .then((res) => setData(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [range, page]);

  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <LoadingModalComponent show={loading} />
          <div className="card-body">
            <div className="row mb-2">
              <div className="col-xl-6">
                <form className="row gy-2 gx-2 align-items-center justify-content-xl-start justify-content-between">
                  <div className="col">
                    <CustomDateRangePicker />
                  </div>
                  <div className="col">
                    <a onClick={() => setSearchParams("")} className="btn border rounded">
                      <i className="mdi mdi-autorenew" />
                    </a>
                  </div>
                </form>
              </div>
              <div className="col">
                <form className="d-flex justify-content-end">
                  <a href="javascript: void(0);" className="btn border rounded">Хэвлэх</a>
                </form>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-centered table-bordered mb-0">
                <thead>
                  <tr className="text-center">
                    <th className="fw-normal col-2">Огноо</th>
                    <th className="fw-normal col-2">Дайврын тоо</th>
                    <th className="fw-normal col-2">Олгосон тоо</th>
                    <th className="fw-normal col-2">Хүргэсэн тоо</th>
                    <th className="fw-normal col-2">Төлбөр</th>
                    <th className="fw-normal col-2">Хадгалалт</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.data.map((k, i) => (
                    <tr key={i} className="text-center">
                      <td>{k?.date}</td>
                      <td>{k?.totalCount}</td>
                      <td>{k?.allotedCount}</td>
                      <td>{k?.deliveredCount}</td>
                      <td>{formatCurrency(k?.totalAmount)}</td>
                      <td>{formatCurrency(k?.totalProfit)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <CustomPagination total={data?.total} limit={DAYS_PER_PAGE} />
          </div>
        </div>
      </div>
    </div>
  );
}
